import React, { useEffect, useState } from "react";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Switch, FormControlLabel } from "@material-ui/core";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import {
  TextInput,
  SimpleForm,
  useDataProvider,
  SelectInput,
  SaveButton,
  Toolbar,
  useNotify,
  BooleanInput,
  NumberInput,
  useInput,
} from "react-admin";
import {
  PageContainer,
  Content,
  HeaderRow,
  Title,
  Subtitle,
  TabsCard,
  TabPanelContainer,
  SectionTitle,
  SectionHint,
  SectionCard,
  FormStack,
  PhoneInputWrapper,
  PaymentList,
  PaymentItem,
  PaymentInfo,
} from "./styles";
import { updateAll } from "../../Providers/PaymentsProvider";

const Dashboard = (props: any) => {
  const [data, setData] = useState<any>({});
  const [hasPayment, setHasPayment] = useState<boolean>(false);
  const [payments, setPayments] = useState<any>([]);
  const [
    showWhatsappDeliveryPrice,
    setShowWhatsappDeliveryPrice,
  ] = useState<any>(false);
  const [whatsappDeliveryType, setWhatsappDeliveryType] = useState<any>(false);
  const dataProvider = useDataProvider();
  const getData = React.useCallback(() => {
    dataProvider
      .getList("payment", {
        pagination: { page: 1, perPage: 1000 },
        sort: { order: "ASC", field: "id" },
      })
      .then((res: any) => {
        if (res)
          setPayments(
            res.data.sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0))
          );
        console.log("payment res", res.data);
      })
      .catch((error: any) => {
        //console.log(error);
      });

    dataProvider
      .getOne("configuration", {})
      .then((res: any) => {
        let whatsappDeliveryType;
        setHasPayment(res.data.hasPayment);
        if (res) setData({ ...res.data, whatsappDeliveryType });
        if (res.data.whatsappDeliveryTax < 1) {
          setWhatsappDeliveryType(res.data.whatsappDeliveryTax);
        } else {
          setWhatsappDeliveryType(1);
          setShowWhatsappDeliveryPrice(true);
        }

        //console.log("res", res.data);
      })
      .catch((error: any) => {
        //console.log(error);
      });
  }, [dataProvider, setData]);

  useEffect(() => {
    getData();
  }, [getData]);
  //console.log("log", props);

  const CustomPhoneInput = (props: any) => {
    const {
      input: { name, onChange },
    } = useInput(props);

    const handleChange = (name, value) => {
      onChange(value);
      //setPhoneInputNumber(value);
      // dispatch(setTheme({ [name]: colors.color }));
      //setThemeColors({ ...themeColors, [name]: colors.color });
    };

    return (
      <PhoneInputWrapper>
        <label>{props.label}</label>
        <PhoneInput
          country="br"
          value={props.defaultValue}
          onChange={(colors: any) => handleChange(name, colors)}
        />
      </PhoneInputWrapper>
    );
  };

  const ConfigurationToolbar = (props: any) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    return (
      <Toolbar {...props} pristine={false}>
        <SaveButton
          label="Salvar"
          onSave={(data: any) => {
            let whatsappDeliveryTax = 0;
            if (data.whatsappDeliveryType < 1)
              whatsappDeliveryTax = data.whatsappDeliveryType;
            else {
              whatsappDeliveryTax = data.whatsappDeliveryTax;
            }
            console.log("dados", {
              id: 1,
              data: { ...data, whatsappDeliveryTax },
            });

            dataProvider
              .update("configuration", {
                id: 1,
                data: { ...data, whatsappDeliveryTax, hasPayment },
              })
              .then((res: any) =>
                updateAll(payments)
                  .then((res: any) => {
                    console.log(res);
                    notify("Dados atualizados com sucesso!", "info");
                  })
                  .catch((error: any) => {
                    //console.log(error);
                  })
              );
            return { ...data, notify: true };
          }}
          submitOnEnter={false}
        />
      </Toolbar>
    );
  };

  const validateConfiguration = (values: any) => {
    const errors: any = {};

    if (values.hasWhatsappDelivery && !values.whatsapp) {
      errors.whatsapp = [
        "Você precisa configurar o número de WhatsApp para receber pedidos.",
      ];
    }

    return errors;
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handlePaymentSwitchChange = (id) => {
    const oldPayments = payments.filter((i) => i.id !== id);
    const actualPayments = payments.find((i) => i.id === id);
    actualPayments.isActive = !actualPayments.isActive;

    setPayments(
      [...oldPayments, actualPayments].sort((a, b) =>
        a.id < b.id ? -1 : a.id > b.id ? 1 : 0
      )
    );
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <TabPanelContainer>{children}</TabPanelContainer>}
      </div>
    );
  }

  return (
    <PageContainer>
      <Content>
        <HeaderRow>
          <Title>Configurações</Title>
          <Subtitle>Ajuste os dados do estabelecimento e regras de pedido.</Subtitle>
        </HeaderRow>
        <TabsCard>
          <SimpleForm
            validate={validateConfiguration}
            toolbar={<ConfigurationToolbar />}
          >
            <AppBar position="static">
              <Tabs value={value} onChange={handleChange}>
                <Tab label="Informações Básicas" />
                <Tab label="Configurações" />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0} className="tabContainer">
              <SectionTitle>Informações básicas</SectionTitle>
              <SectionCard>
                <FormStack>
                  <TextInput source="name" defaultValue={data?.name} label="Nome" />
                  <SelectInput
                    label="Moeda"
                    source="currency"
                    defaultValue={data?.currency}
                    choices={[
                      { id: "R$", name: "R$" },
                      { id: "€", name: "€" },
                      { id: "$", name: "$" },
                    ]}
                  />
                </FormStack>
              </SectionCard>

              <SectionTitle>Contato</SectionTitle>
              <SectionCard>
                <FormStack>
                  <CustomPhoneInput
                    source="phone"
                    defaultValue={data?.phone}
                    label="Telefone"
                  />
                  <CustomPhoneInput
                    source="whatsapp"
                    defaultValue={data?.whatsapp}
                    label="Whatsapp"
                  />
                  <TextInput
                    source="email"
                    defaultValue={data?.email}
                    label="Email"
                  />
                  <TextInput
                    source="website"
                    defaultValue={data?.website}
                    label="Site"
                  />
                  <TextInput
                    source="instagram"
                    defaultValue={data?.instagram}
                    label="Instagram"
                  />
                  <TextInput
                    source="facebook"
                    defaultValue={data?.facebook}
                    label="Facebook"
                  />
                </FormStack>
              </SectionCard>

              <SectionTitle>Wi-Fi</SectionTitle>
              <SectionHint>
                Caso queira compartilhar a senha do seu Wi-Fi com os clientes,
                informe abaixo.
              </SectionHint>
              <SectionCard>
                <FormStack>
                  <TextInput source="wifi" defaultValue={data?.wifi} label="Wifi" />
                  <TextInput
                    source="wifiPassword"
                    defaultValue={data?.wifiPassword}
                    label="Senha do Wifi"
                  />
                </FormStack>
              </SectionCard>
            </TabPanel>

            <TabPanel value={value} index={1} className="tabContainer">
              <SectionTitle>Pedidos</SectionTitle>
              <SectionCard>
                <BooleanInput
                  source="hasWhatsappDelivery"
                  defaultValue={data?.hasWhatsappDelivery}
                  label={"Habilitar pedidos pelo WhatsApp"}
                />
              </SectionCard>

              <SectionTitle>Geral</SectionTitle>
              <SectionCard>
                <BooleanInput
                  source="hasSearch"
                  defaultValue={data?.hasSearch}
                  label={"Habilitar busca de produtos"}
                />
              </SectionCard>

              <SectionTitle>Entrega</SectionTitle>
              <SectionCard>
                <FormStack>
                  <SelectInput
                    source="whatsappDeliveryType"
                    label="Taxa de entrega"
                    defaultValue={whatsappDeliveryType}
                    onChange={(e) => {
                      setWhatsappDeliveryType(e.target.value);
                      if (e.target.value >= 1) setShowWhatsappDeliveryPrice(true);
                      else setShowWhatsappDeliveryPrice(false);
                    }}
                    choices={[
                      { id: -2, name: "Retirar no balcão" },
                      { id: -1, name: "Combinar" },
                      { id: 0, name: "Grátis" },
                      { id: 1, name: "Preço fixo" },
                    ]}
                  />
                  {showWhatsappDeliveryPrice && (
                    <NumberInput
                      format={(v: number) => v / 100}
                      parse={(v: string) => parseFloat(v) * 100}
                      source="whatsappDeliveryTax"
                      defaultValue={
                        data?.whatsappDeliveryTax < 0
                          ? 0
                          : data?.whatsappDeliveryTax
                      }
                      label="Preço de entrega"
                      helperText="Caso tenha entrega grátis, deixar este campo como 0."
                      step={0.01}
                      min={0}
                    />
                  )}
                  <BooleanInput
                    source="hasTakeAway"
                    defaultValue={data?.hasTakeAway}
                    label={"Habilitar retirada em loja"}
                  />
                </FormStack>
              </SectionCard>

              <SectionTitle>Formas de pagamento</SectionTitle>
              <SectionCard>
                <FormControlLabel
                  control={
                    <Switch
                      color="primary"
                      checked={hasPayment}
                      onChange={() => setHasPayment(!hasPayment)}
                    />
                  }
                  label="Habilitar métodos de pagamento"
                />
                <PaymentList
                  style={{
                    pointerEvents: hasPayment ? "all" : "none",
                    opacity: hasPayment ? 1 : 0.2,
                  }}
                >
                  {payments?.map((item) => {
                    return (
                      <PaymentItem key={item.id}>
                        <PaymentInfo>
                          <img src={item.icon} alt={item.name} />
                          {item.name}
                        </PaymentInfo>
                        <Switch
                          color="primary"
                          checked={item.isActive}
                          onChange={() => handlePaymentSwitchChange(item.id)}
                        />
                      </PaymentItem>
                    );
                  })}
                </PaymentList>
              </SectionCard>
            </TabPanel>
          </SimpleForm>
        </TabsCard>
      </Content>
    </PageContainer>
  );
};

export default Dashboard;
